import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { PageHeader } from "@/components/dashboard/ui";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({
    first_name: user?.first_name || "", last_name: user?.last_name || "", phone: user?.phone || "",
    practice: user?.practice || "", practice_address: user?.practice_address || "", city: user?.city || "",
    canton: user?.canton || "", country: user?.country || "Suisse", billing_info: user?.billing_info || "",
    contact_method: user?.contact_method || "email",
  });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/auth/profile", f); setUser(data); toast.success("Profil mis à jour"); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return (
    <div>
      <PageHeader title="Mon profil" subtitle="Gérez vos informations personnelles et celles de votre cabinet." />
      <div className="bg-white rounded-xl border border-slate-200 p-6 max-w-2xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div><Label>Prénom</Label><Input value={f.first_name} onChange={(e) => set("first_name", e.target.value)} className="mt-1" data-testid="profile-firstname" /></div>
          <div><Label>Nom</Label><Input value={f.last_name} onChange={(e) => set("last_name", e.target.value)} className="mt-1" /></div>
          <div><Label>E-mail</Label><Input value={user?.email} disabled className="mt-1 bg-slate-50" /></div>
          <div><Label>Téléphone</Label><Input value={f.phone} onChange={(e) => set("phone", e.target.value)} className="mt-1" /></div>
          <div><Label>Cabinet</Label><Input value={f.practice} onChange={(e) => set("practice", e.target.value)} className="mt-1" /></div>
          <div><Label>Adresse du cabinet</Label><Input value={f.practice_address} onChange={(e) => set("practice_address", e.target.value)} className="mt-1" /></div>
          <div><Label>Ville</Label><Input value={f.city} onChange={(e) => set("city", e.target.value)} className="mt-1" /></div>
          <div><Label>Canton</Label><Input value={f.canton} onChange={(e) => set("canton", e.target.value)} className="mt-1" /></div>
          <div className="sm:col-span-2"><Label>Informations de facturation</Label><Textarea rows={2} value={f.billing_info} onChange={(e) => set("billing_info", e.target.value)} className="mt-1" /></div>
        </div>
        <Button className="mt-6 bg-primary" onClick={save} disabled={saving} data-testid="profile-save">{saving ? "Enregistrement..." : "Enregistrer"}</Button>
      </div>
    </div>
  );
}
